
(async function () {
    const sendWelcomeBtns = document.querySelectorAll(".btn-sendwelcome")
    sendWelcomeBtns.forEach(sendWelcomeBtn => {
        //console.log("adding event listener")
        sendWelcomeBtn.addEventListener("click", async (e) => {
            console.log("welcome click")
            e.preventDefault()
            const parent = sendWelcomeBtn.parentElement
            sendWelcomeBtn.style.display = "none"
            const infoEl = document.createElement("div")
            infoEl.innerHTML = `<div style="background-color:grey;color:black;padding:6px;">Sending</div>`
            parent.appendChild(infoEl)

            var artistId = sendWelcomeBtn.dataset.artistid
            //console.log("send welcome to", artistId)
            if (artistId) {
                try {
                    const response = await fetch('/api/ArtistApi/sendwelcome', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(artistId)
                    })
                    if (response.ok) {
                        infoEl.innerHTML = `<div style="background-color:green;color:white;padding:6px;">Welcome Message Sent</div>`
                        parent.appendChild(infoEl)
                        // setTimeout(() => {
                        //     infoEl.remove()
                        //     sendWelcomeBtn.style.display = "block"
                        // }, 2000)
                    } else {
                        const errorText = await response.text()
                        infoEl.innerHTML = `<div style="background-color:red;color:white;padding:6px;">Request failed: ${response.status}</div>`
                        parent.appendChild(infoEl)
                        setTimeout(() => {
                            infoEl.remove()
                            sendWelcomeBtn.style.display = "block"
                        }, 2000)
                    }
                } catch (error) {
                    console.log("Request failed:", error)
                    infoEl.innerHTML = `<div style="background-color:red;color:white;padding:6px;">Request failed: ${error}</div>`
                    parent.appendChild(infoEl)
                    setTimeout(() => {
                        infoEl.remove()
                        sendWelcomeBtn.style.display = "block"
                    }, 2000)
                }
            }
        })
    })

    const confirmationForm = document.querySelector(".artistconfirmation")
    if (confirmationForm) {
        var artists = confirmationForm.querySelectorAll("input[name='id']")
        var btn = confirmationForm.querySelector("button.confirm")
        if (artists.length == 0) {
            btn.style.display = "none"
        } else {
            btn.style.display = "block"
            btn.removeAttribute("disabled")
        }
        btn.addEventListener("click", async (e) => {
            const msgEl = document.querySelector(".confirmmessage")     
            const ids = []
            artists.forEach(artist => {
                if (artist.checked) {
                    ids.push(parseInt(artist.value))
                    artist.checked = false;
                }
            })
            if (ids.length) {
                btn.setAttribute("disabled", "disabled")
                try {
                    const response = await fetch('/api/ArtistApi/confirm', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(ids)
                    })
                    const data = await response.json()
                    data.forEach(id => {
                        const inp = confirmationForm.querySelector(`input[value='${id}']`)
                        const ctr = inp.closest(".artistselection")
                        const artistlink = ctr.querySelector(".artistlink")
                        artistlink.innerHTML += " [Awaiting Confirmation Process]"
                        inp.closest("label").remove()
                    })
                    msgEl.style.display = "block"
                    setTimeout(() => {
                        msgEl.style.display = "none"
                    }, 8000)
                } catch (error) {
                    console.error("Request failed:", error)
                } finally {
                    btn.removeAttribute("disabled") // Re-enable button when done
                }
            } else {
                alert("Select one or more artists")
            }
        })
    }

    const navListing = document.getElementById("nav-listing");
    if (navListing) {
        const artists = navListing.querySelectorAll(".artist");

        artists.forEach(artistEl => {
            const artistid = parseInt(artistEl.dataset.id, 10); // Parse to int for backend
            const listingEl = artistEl.querySelector("input[name='ListingNumber']");
            const oldvalueEl = artistEl.querySelector(".oldvalue");

            if (!listingEl || !oldvalueEl) return; // Guard clause against missing elements

            let currentListingNumber = listingEl.value;

            listingEl.addEventListener("input", async (event) => {
                const newValue = event.target.value;
                if (newValue !== currentListingNumber) {
                    const updatedEl = document.createElement("span");
                    updatedEl.style.backgroundColor = "yellow";
                    updatedEl.innerText = `Old value: ${currentListingNumber}`;

                    const notificationEl = document.createElement("span");
                    notificationEl.style.backgroundColor = "lightgreen";
                    notificationEl.innerText = "updating...";

                    // Show "updating..."
                    oldvalueEl.replaceChildren(notificationEl);

                    // Capture the value to replace current text *before* the async call
                    const previousValue = currentListingNumber;
                    currentListingNumber = newValue;

                    try {
                        const response = await fetch('/api/ArtistApi/setlistingnumber', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({
                                artistid: artistid,
                                listingNumber: parseInt(newValue || 0, 10) // Convert to int for [FromBody]
                            })
                        });

                        if (!response.ok) throw new Error("Server error");

                        // Success: show the yellow "Old value" label
                        oldvalueEl.replaceChildren(updatedEl);
                    } catch (error) {
                        console.error("Request failed:", error);
                        // Failure: Rollback UI and state
                        currentListingNumber = previousValue;
                        oldvalueEl.replaceChildren(); // Clear the "updating..." status
                    }
                }
            });
        });
    }

})()